import { memo } from 'react';
import isEqual from 'react-fast-compare';

var fastCompare = function fastCompare(MyComponent) {
  return memo(MyComponent, isEqual);
};

export { fastCompare };
